// Environment Detection Utility
// This file provides environment detection for the frontend

/**
 * Get the current environment based on URL or other indicators
 * @returns {string} The current environment ('prod', 'develop')
 */
export const getCurrentEnvironment = () => {
  // Prefer hostname on deployed domains so the correct video/config is used regardless of build env
  const hostname = window.location.hostname;
  if (hostname.includes('kbhclassroom.com')) return 'prod';
  if (hostname.includes('develop') || hostname.includes('kbhdemo')) return 'develop';

  // Localhost: use query param or REACT_APP_ENVIRONMENT, then default develop
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const urlParams = new URLSearchParams(window.location.search);
    const envParam = urlParams.get('env');
    if (envParam) return envParam;
    if (process.env.REACT_APP_ENVIRONMENT) return normalizeEnv(process.env.REACT_APP_ENVIRONMENT);
    return 'develop';
  }

  // Fallback: build-time env, normalized so "production" -> "prod"
  if (process.env.REACT_APP_ENVIRONMENT) return normalizeEnv(process.env.REACT_APP_ENVIRONMENT);
  return 'develop';
};

function normalizeEnv(env) {
  if (env === 'production' || env === 'prod') return 'prod';
  return env;
}

/**
 * Get the video name based on the current environment
 * @returns {string} The video name to display
 */
export const getVideoName = () => {
  const environment = getCurrentEnvironment();
  // Prod uses the main intro video; develop uses the demo video
  if (environment === 'prod') return 'KBH classroom intro.mp4';
  return 'eagleLanding.mp4';
};
